import { GetFormalOffersResponse } from '@iwoca/lapi-client/edge';
import { hasRBLOffer, interestOnlyOffer } from './xsell.helpers';

//DE formal offer combinations:

//x_sell
// 1. RBL, flexi12 and flexi24 offer: show  2 cards => flexi card w/duration radio buttons and RBL card
// 2. Interest-only, flexi12, and flexi24 offer: show  2 cards => flexi card w/duration radio buttons and interest-only card
// 3. Longer duration flexi offers: show 2 cards=> one flexi card w/ 12 and 24 durations, one flexi card with 36-60 month durations

//duration_choice
// 4. Flexi12, and flexi24 offer: show 2 cards=> 2 flexi cards for each duration

//interest-only_only
// 5. Interest-only offer: show 1 card=> interest-only card

type TXSellOfferType =
    | 'duration_choice'
    | 'interest-only_only'
    | 'x_sell'
    | 'dual_choice';

export const getXSellOfferType = (
    formal_offers: NonNullable<GetFormalOffersResponse['data']>['formal_offers']
): TXSellOfferType => {
    if (
        formal_offers.length === 1 &&
        Boolean(interestOnlyOffer(formal_offers))
    ) {
        return 'interest-only_only';
    } else {
        const hasRblOrInterestOnlyOffer =
            hasRBLOffer(formal_offers) || interestOnlyOffer(formal_offers);
        if (formal_offers.length === 2 && !hasRblOrInterestOnlyOffer) {
            return 'dual_choice';
        } else if (formal_offers.length > 2 && !hasRblOrInterestOnlyOffer) {
            return 'duration_choice';
        } else return 'x_sell';
    }
};
